import intl from 'localization/components'
import { FormattedMessage, useIntl } from 'react-intl'
import { EquityCategory, TemplateType } from 'types/queries'
import numeral from 'numeral'
import { handleUnit } from '../Rule'
import { EQUITY_WITHOUT_DIVIDEND } from '../../PolicyBuilder.model'

type EquityData = {
  apiData: EquityCategory
  template?: TemplateType
}
function EquityContent({ apiData, template }: EquityData) {
  const { formatMessage } = useIntl()

  if (!template || !apiData.tolerance) {
    return <FormattedMessage id={intl.creditPolicyNew('no-data-yet')} />
  }
  return (
    <FormattedMessage
      id={intl.creditPolicyNew('equity-node-content')}
      values={{
        category: Number(apiData.category === EQUITY_WITHOUT_DIVIDEND),
        tolerance: formatMessage({
          id: intl.creditPolicyNew(apiData.tolerance),
        }).toLowerCase(),
        min: handleUnit(numeral(apiData.value_a).format('0,0'), template),
        max: handleUnit(numeral(apiData.value_b).format('0,0'), template),
      }}
    />
  )
}

export default EquityContent
